export enum PlatformType {
  BROWSER = "BROWSER",
  ELECTRON_RENDERER = "ELECTRON_RENDERER",
}

export enum PlatformInstaller {
  NONE = "NONE",
  MAC_STORE = "MAC_STORE",
}

export enum PlatformOs {
  UNKNOWN = "UNKNOWN",
  MAC_OS = "MAC_OS",
  WINDOWS = "WINDOWS",
}

export interface IPlatformConfig {
  readonly type: PlatformType;
  readonly installer: PlatformInstaller;
  readonly os: PlatformOs;
}
